/* 🤖 this file was generated by svg-to-ts */
export const mgcIconSectorCuteFi: {
  name: 'sector-cute-fi';
  data: string;
} = {
  name: 'sector-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.08 2.297c-.858.191-1.735.761-2.22 1.443-.523.736-.734 1.523-.819 3.048-.051.919-.051 8.695-.001 9.612.048.855.095 1.222.224 1.737.338 1.353 1.245 2.261 2.596 2.599.94.235 1.621.262 6.54.263 4.226.001 5.243-.026 6.034-.161 1.255-.213 2.082-.704 2.683-1.593.808-1.194.853-2.452.162-4.465a28.9 28.9 0 0 0-1.076-2.6 17.874 17.874 0 0 0-6.183-7.12c-1.166-.777-2.125-1.279-3.58-1.872-1.217-.497-2.017-.75-2.801-.888-.402-.071-1.246-.072-1.559-.003"/></svg>`
};
